import { Action, ActionCreator } from 'typescript-fsa';
import { Observable, OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function isTypeOfAny(
  actionFactories: ActionCreator<Action<any>>[],
): OperatorFunction<Action<any>, Action<any>> {
  function isTypeOfOperation(source: Observable<Action<any>>) {
    return source.pipe(
      filter(
        (action) => actionFactories.some((actionFactory) => actionFactory.match(action)),
      ),
    );
  }

  return isTypeOfOperation;
}
